/* ============================================================
   Textblock eines Beitrags an das Hintergrundraster anschliessen.

   Ziel: Die UNTERKANTE des Blocks soll immer bei 0,9 der Rasterzelle liegen, die sie
   anschneidet — also eine Zehntelzelle vor der nächsten Linie. Damit ist der Block unten
   sichtbar von einer Rasterlinie eingefasst, egal wie lang der Text ist.

   Gerechnet wird deshalb mit der LAGE der Unterkante im Dokument, nicht mit der Höhe des
   Blocks. Beides ist nur dasselbe, wenn der Block genau auf einer Linie beginnt — das tut
   er hier nicht (nachgemessen sass seine Oberkante 0,43 Zellen neben der Linie). Eine
   Höhe von „n Zellen minus 0,1“ hätte diesen Versatz unverändert an die Unterkante
   weitergereicht und das Ziel verfehlt.

   Wo die Linien liegen, sagt --grid-phase-y: waagerechte Linien sitzen bei
   docY ≡ phase (mod Zelle). Die Variable setzt assets/grid-background.js, dort steht auch
   die Herleitung.

   Vergroessert wird immer, nie verkleinert — der Zuschlag ist damit höchstens eine Zelle.

   Warum ein Skript und kein CSS: Die nötige Höhe hängt vom Text ab, und CSS kann die
   eigene Inhaltshöhe nicht in eine Rechnung einsetzen. round() gäbe es zwar in calc(),
   braucht aber ebenfalls einen bekannten Wert.

   min-height statt height: Sollte der Inhalt nach dem Setzen doch noch wachsen (Bild lädt
   nach, Schrift wechselt), wächst der Block mit, statt seinen Text abzuschneiden. Beim
   nächsten Durchlauf wird ohnehin neu gerechnet.

   --cell setzt assets/grid-background.js am <html>. Läuft dieses Skript zu früh, steht dort
   noch nichts — deshalb wird nach dem Laden UND nach dem nächsten Layout gerechnet, und
   ohne gültige Zellgröße passiert gar nichts.
   ============================================================ */
(function () {
  'use strict';

  // Wie weit in die angeschnittene Zelle die Unterkante reichen soll. 0.9 = kurz vor der
  // nächsten Linie. Am Element über data-raster-anteil überschreibbar.
  var STANDARD_ANTEIL = 0.9;

  function wert(name) {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name));
  }

  function anpassen(el) {
    var c = wert('--cell');
    if (!(c > 0)) return;                 // Raster noch nicht vermessen
    var phase = wert('--grid-phase-y');
    if (!isFinite(phase)) phase = 0;

    var anteil = parseFloat(el.dataset.rasterAnteil);
    if (isNaN(anteil)) anteil = STANDARD_ANTEIL;

    // Erst zurücksetzen, sonst misst man die zuletzt gesetzte Höhe und der Block wüchse
    // von Durchlauf zu Durchlauf weiter.
    el.style.minHeight = '';
    var r = el.getBoundingClientRect();
    var oben = r.top + window.scrollY;
    var unten = oben + r.height;

    // Erlaubte Lagen der Unterkante: docY ≡ phase + anteil × Zelle (mod Zelle).
    // Gesucht ist die nächste davon, die nicht über der jetzigen Unterkante liegt.
    var ziel = phase + anteil * c;
    var k = Math.ceil((unten - ziel) / c);
    var neueUnterkante = ziel + k * c;

    el.style.minHeight = (neueUnterkante - oben) + 'px';
  }

  function alle() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-raster-hoehe]'),
      anpassen
    );
  }

  function boot() {
    alle();
    // Nach dem nächsten Layout noch einmal: Beim ersten Lauf kann --cell fehlen, weil
    // grid-background.js seine Messung selbst erst nach dem Layout macht.
    requestAnimationFrame(alle);
    window.addEventListener('load', alle);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alle);

    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(alle, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
